var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_255:3152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5173 14.0042H19.3103C19.6912 14.0042 20 13.6906 20 13.3039V0.700248C20 0.313407 19.6912 0 19.3103 0H0.689697C0.308685 0 0 0.313562 0 0.700248V13.3039C0 13.6906 0.308685 14.004 0.689697 14.004H15.5173V14.0042Z",
    fill: "#F29C1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 9.45264V13.3038C19.9989 13.6901 19.6909 14.0028 19.3103 14.0039H0.689697C0.309143 14.0028 0.00106812 13.6901 0 13.3038V9.45279H20V9.45264Z",
    fill: "#C03A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 4.55127H20V9.45269H0V4.55127Z",
    fill: "#4C8056"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_255:3152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLth);
export default __webpack_public_path__ + "static/media/icon-lth.81654d0a.svg";
export { ForwardRef as ReactComponent };